import { ReadFile } from '@paragon/client-tools';

import { DesignService } from '../connections';

export function postParseQuantitiesFromCountFile(file: ReadFile): Promise<Record<string, number>> {
  return DesignService.post('countUtilities/parseQuantitiesFromCountFile', { data: file });
}
